import React from 'react';
import TableMui, { TableProps } from '@material-ui/core/Table';

export const Table: React.FC<TableProps> = ({ children, ...rest }) => {
	return <TableMui {...rest}>{children}</TableMui>;
};
